import { render } from "./RecordIndexView.vue?vue&type=template&id=0f79b0d7&scoped=true"
import script from "./RecordIndexView.vue?vue&type=script&lang=js"
export * from "./RecordIndexView.vue?vue&type=script&lang=js"

import "./RecordIndexView.vue?vue&type=style&index=0&id=0f79b0d7&scoped=true&lang=css"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f79b0d7"]])

export default __exports__